/**
 * Qidiruv uchun alifbo normalizatsiyasi (kirill ↔ lotin, o'zbekcha).
 *
 * Katalogda bir xil til ikki alifboda yozilgan: "Жип политсия" ham,
 * "Jip politsiya" ham bor. Klaviatura holatiga qarab sotuvchi katalogning
 * bir qismini umuman topa olmaydi.
 *
 * Nom ham, so'rov ham bitta kanonik shaklga keltiriladi. Tarjima emas —
 * faqat harflarni moslashtirish.
 *
 * DIQQAT: bu fayl `products/translit.py` ning aynan nusxasi. Backend
 * `search_key` ni shu qoida bo'yicha saqlaydi; biri o'zgarsa, ikkinchisi
 * ham o'zgarishi shart, aks holda server va brauzer boshqa natija beradi.
 */

// Ko'p harfli almashinuvlar avval turishi shart (ё → yo, ц → ts ...).
const CYRILLIC: Array<[RegExp, string]> = [
  [/ё/g, 'yo'], [/ж/g, 'j'], [/ц/g, 'ts'], [/ч/g, 'ch'], [/ш/g, 'sh'],
  [/щ/g, 'sh'], [/ю/g, 'yu'], [/я/g, 'ya'], [/[ъь]/g, ''],
  [/а/g, 'a'], [/б/g, 'b'], [/в/g, 'v'], [/г/g, 'g'], [/д/g, 'd'],
  [/е/g, 'e'], [/з/g, 'z'], [/и/g, 'i'], [/й/g, 'y'], [/к/g, 'k'],
  [/л/g, 'l'], [/м/g, 'm'], [/н/g, 'n'], [/о/g, 'o'], [/п/g, 'p'],
  [/р/g, 'r'], [/с/g, 's'], [/т/g, 't'], [/у/g, 'u'], [/ф/g, 'f'],
  [/х/g, 'h'], [/ы/g, 'i'], [/э/g, 'e'],
  // O'zbek kirilligiga xos
  [/ў/g, 'o'], [/қ/g, 'q'], [/ғ/g, 'g'], [/ҳ/g, 'h'],
];

// Apostrofning barcha ko'rinishi bir xil qabul qilinadi.
const APOS = "'‘’ʻʼ`´";

const LATIN: Array<[RegExp, string]> = [
  [new RegExp(`o[${APOS}]`, 'g'), 'o'],
  [new RegExp(`g[${APOS}]`, 'g'), 'g'],
  [/x/g, 'h'],   // x va h o'zbekchada doim chalkashtiriladi
];

/** Matnni qidiruv uchun kanonik lotin shakliga keltiradi. */
export function normalize(text: string | null | undefined): string {
  if (!text) return '';
  let s = String(text).normalize('NFKC').toLowerCase();

  for (const [rx, repl] of CYRILLIC) s = s.replace(rx, repl);
  for (const [rx, repl] of LATIN) s = s.replace(rx, repl);

  s = s.replace(/×/g, 'h');            // yuqorida x → h bo'lgani uchun izchil
  s = s.replace(/[^a-z0-9 ]+/g, ' ');  // "0855-188" va "0855 188" bir xil
  return s.replace(/\s+/g, ' ').trim();
}

/**
 * So'rov matndan topiladimi? So'z bo'yicha tekshiradi, ya'ni "jip 0855"
 * tartibidan qat'i nazar ishlaydi.
 */
export function matches(haystack: string | null | undefined, query: string): boolean {
  const key = normalize(query);
  if (!key) return true;
  const target = normalize(haystack);
  return key.split(' ').every((w) => target.includes(w));
}
